import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Button} from "primereact/button";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {Calendar} from "primereact/calendar";
import {setClearFilters} from "../../../../redux/actions/actions";
import {getStatusStatisticExcel} from "../../../../redux/api/apiStatusStatisticsList";
// import {Checkbox} from "primereact/checkbox";
import {ToggleButton} from "primereact/togglebutton";
import {Dropdown} from "primereact/dropdown";

const StatusStatisticsListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const exportLoading = useAppSelector(state => state.StatisticsStatusListReducer.exportLoading);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const statisticPermissions = checkPermissions(rolesVision, 'Statistic');
    const statisticsStatusList = useAppSelector(state => state.StatisticsStatusListReducer?.statisticsStatusList);
    const [isListLength, setIsListLength] = useState(false);

    const minDate = new Date(2023, 5, 1);   // 01.06.2023  (месяцы с 0)

    const getDefaultStartTime = () => {
        return new Date("2024-10-29 00:00:00");
    };

    const getDefaultEndTime = () => {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    };

    const getDefaultStartDate = () => {
        return new Date();
    };

    const getDefaultEndDate = () => {
        return new Date();
    };

    useEffect(() => {
        setIsListLength(!!statisticsStatusList?.users?.length);
    }, [statisticsStatusList]);

    const {
        update: hasUpdatePermission,
    } = statisticPermissions;

    let filteredObject = {
        "sort": props.sortData?.sort,
        "filter": props.sortData?.filter,
        ...(props.sortData?.branchId != null ? {branchId: props.sortData.branchId} : {}),
    };

    const formattedBranches = props.branches?.map((branch: { id: number; name: string }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    })) ?? [];

    const isDisabled = () => {
        return !props.endTime || !props.startTime || !props.filterDateTime || !props.filterEndDateTime;
    };

    return (
        <>
        <div className="table-buttons">
            <div className="text-normal-weight flex align-items-center">
                <ToggleButton style={{fontWeight: 'normal'}} onLabel={'Мої активності'} offLabel={'Всі'} checked={props.activity} onChange={(e) => {
                    props.setActivity(!props.activity);
                    props.setToggleButtonActivity(!props.toggleButtonActivity);
                    props.activityChangedManuallyRefStatus.current = true;
                }} className="w-10rem mb-2 mr-2 font-normal"/>
                <div className="flex field align-items-center max-w-15rem ml-4 desktop-filter">
                    <span className="title pt-2" style={{width: '35px'}}>З*</span>
                    <Calendar disabled={props.allTimeChecked} className="mt-2" value={props.filterDateTime ? props.filterDateTime : null} onChange={(e: any) => {
                        // options.filterCallback(e.value, options.index);
                        props.setFilterDateTime(e.value)
                    }} onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year &&
                                parsed >= minDate;

                            props.setFilterDateTime(valid ? parsed : null);
                        }
                    }} onFocus={(e: any) => {
                        if (props.filterDateTime) {
                            props.setFilterDateTime(null);
                        }
                    }} onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            props.setFilterDateTime(null);
                        }
                        if (!props.filterDateTime) {
                            props.setFilterDateTime(getDefaultStartDate());
                        }
                    }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                    maxDate={new Date()}
                    dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                    <Calendar
                        key={`start-time-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2"
                        placeholder="00:00"
                        value={props.startTime ? props.startTime : null}
                        timeOnly
                        hourFormat="24"
                        disabled={props.allTimeChecked}
                        onChange={(e) => {
                            if (e.value) props.setStartTime(e.value);
                        }}
                        onFocus={() => {
                            props.setStartTime(null);
                        }}
                        onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            let digits = input.value.replace(/\D/g, "").slice(0, 4);
                            const HH = digits.slice(0, 2);
                            const MM = digits.slice(2, 4);

                            const display = HH + (digits.length > 2 ? ":" + MM : "");

                            if (input.value !== display) {
                                const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                input.value = display;
                                input.setSelectionRange(caret, caret);
                            }

                            if (digits.length === 4) {
                                const h = parseInt(HH, 10);
                                const m = parseInt(MM, 10);
                                const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                if (valid) {
                                    const base = props.startTime ? new Date(props.startTime) : new Date();
                                    base.setHours(h, m, 0, 0);
                                    props.setStartTime(base);
                                }
                            }
                        }}
                        onBlur={() => {
                            if (!props.startTime) {
                                props.setStartTime(getDefaultStartTime());
                            }
                        }}
                    />
                </div>
                <div className="flex field align-items-center max-w-15rem ml-2 desktop-filter">
                    <span className="title pt-2" style={{width: '35px'}}>По*</span>
                    <Calendar className="mt-2" disabled={props.allTimeChecked} value={props.filterEndDateTime ? props.filterEndDateTime : null} onChange={(e: any) => {
                        props.setFilterEndDateTime(e.value)
                    }} onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year &&
                                parsed >= minDate;

                            props.setFilterEndDateTime(valid ? parsed : null);
                        }
                    }} onFocus={(e: any) => {
                        if (props.filterEndDateTime) {
                            props.setFilterEndDateTime(null);
                        }
                    }} onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            props.setFilterEndDateTime(null);
                        }
                        if (!props.filterEndDateTime) {
                            props.setFilterEndDateTime(getDefaultEndDate());
                        }
                    }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                    maxDate={new Date()}
                    dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                    <Calendar
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2"
                        placeholder="00:00"
                        value={props.endTime ? props.endTime : null}
                        timeOnly
                        hourFormat="24"
                        disabled={props.allTimeChecked}
                        onChange={(e) => {
                            if (e.value) props.setEndTime(e.value);
                        }}
                        onFocus={() => {
                            props.setEndTime(null);
                        }}
                        onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            let digits = input.value.replace(/\D/g, "").slice(0, 4);
                            const HH = digits.slice(0, 2);
                            const MM = digits.slice(2, 4);

                            const display = HH + (digits.length > 2 ? ":" + MM : "");

                            if (input.value !== display) {
                                const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                input.value = display;
                                input.setSelectionRange(caret, caret);
                            }

                            if (digits.length === 4) {
                                const h = parseInt(HH, 10);
                                const m = parseInt(MM, 10);
                                const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                if (valid) {
                                    const base = props.endTime ? new Date(props.endTime) : new Date();
                                    base.setHours(h, m, 0, 0);
                                    props.setEndTime(base);
                                }
                            }
                        }}
                        onBlur={() => {
                            if (!props.endTime) {
                                props.setEndTime(getDefaultEndTime());
                            }
                        }}
                    />
                </div>
                <div className="flex field align-items-center ml-2 desktop-filter">
                    <Dropdown
                        value={props.selectedBranchId}
                        options={formattedBranches}
                        onChange={(e) => props.setSelectedBranchId(e.value ?? null)}
                        optionLabel="label"
                        optionValue="id"
                        placeholder="Оберіть бранч"
                        className="mt-2"
                        style={{minWidth: '220px'}}
                        filter
                        scrollHeight="250px"
                    />
                </div>
                {/* <div
                    className="flex align-items-center border-round-lg border-gray-600 border-1 p-2 pt-1 mb-2 ml-2 desktop-filter">
                    <Checkbox className="mr-2" onChange={e => props.setAllTimeChecked(e.checked)}
                              checked={props.allTimeChecked}/>
                    <label>За весь час</label>
                </div> */}
                <Button disabled={isDisabled()} onClick={() => {props.setHasStartFilter(!props.hasStartFilter);
                    if (props.allTimeChecked === null) {
                        props.setAllTimeChecked(false)
                    }
                }}
                        icon="pi pi-search" className="mb-2 ml-2 desktop-filter"/>
            </div>
            <div className="desktop">
                {hasUpdatePermission && <Button onClick={() => dispatch(getStatusStatisticExcel(filteredObject, jwtToken?.jwtToken))}
                                                label="Експорт таблиці"
                                                loading={exportLoading}
                                                disabled={!isListLength}
                                                icon="pi pi-file-excel"
                                                style={{backgroundColor: '#1d6f42'}}
                                                className="mr-2 mb-2 p-button-success text-white shadow-none"
                />}
                <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри" className="p-button-outlined mr-2 mb-2" onClick={() => {
                    props.resetSorting();
                    props.setActivity(false);

                }}/>
            </div>
            <div className="mobile">
                {hasUpdatePermission && <Button onClick={() => dispatch(getStatusStatisticExcel(filteredObject, jwtToken?.jwtToken))}
                                                icon="pi pi-file-excel"
                                                disabled={!isListLength}
                                                loading={exportLoading}
                                                style={{backgroundColor: '#1d6f42'}}
                                                className="mr-2 mb-2 p-button-success text-white shadow-none"
                />}
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2" onClick={() => dispatch(setClearFilters())}/>
            </div>
        </div>
<div className="flex align-items-center flex-wrap">
            <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-12 field align-items-center mobile-filter mb-1 px-0`}>
                <Dropdown
                    value={props.selectedBranchId}
                    options={formattedBranches}
                    onChange={(e) => props.setSelectedBranchId(e.value ?? null)}
                    optionLabel="label"
                    optionValue="id"
                    placeholder="Оберіть бранч"
                    className="mt-2 w-full"
                    filter
                    showClear
                    scrollHeight="250px"
                />
            </div>
            <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-6 field align-items-center mobile-filter mb-1 px-0`}>
                <span className="title pt-2" style={{minWidth: '25px'}}>З*</span>
                <Calendar disabled={props.allTimeChecked} className="mt-2 w-full" value={props.filterDateTime ? props.filterDateTime : null} onChange={(e: any) => {
                    // options.filterCallback(e.value, options.index);
                    props.setFilterDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year &&
                            parsed >= minDate;

                        props.setFilterDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    if (props.filterDateTime) {
                        props.setFilterDateTime(null);
                    }
                }} onBlur={(e: any) => {
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        props.setFilterDateTime(null);
                    }
                    if (!props.filterDateTime) {
                        props.setFilterDateTime(getDefaultStartDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                <Calendar
                    appendTo="self"
                    id="icon"
                    className="mt-2 ml-2 w-full"
                    placeholder="00:00"
                    value={props.startTime ? props.startTime : null}
                    timeOnly
                    hourFormat="24"
                    disabled={props.allTimeChecked}
                    onChange={(e) => {
                        if (e.value) props.setStartTime(e.value);
                    }}
                    onFocus={() => {
                        props.setStartTime(null);
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        let digits = input.value.replace(/\D/g, "").slice(0, 4);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);

                        const display = HH + (digits.length > 2 ? ":" + MM : "");

                        if (input.value !== display) {
                            const caret = digits.length + (digits.length > 2 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 4) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                        if (valid) {
                            const base = props.startTime ? new Date(props.startTime) : new Date();
                            base.setHours(h, m, 0, 0);
                            props.setStartTime(base);
                        }
                    }
                }}
                onBlur={() => {
                    if (!props.startTime) {
                        props.setStartTime(getDefaultStartTime());
                    }
                }}
            />
            </div>
            <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-6 field align-items-center mobile-filter mb-1 px-0`}>
                <span className="title pt-2" style={{minWidth: '25px'}}>По*</span>
                <Calendar className="mt-2 w-full" value={props.filterEndDateTime ? props.filterEndDateTime : null} onChange={(e: any) => {
                    props.setFilterEndDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year &&
                            parsed >= minDate;

                        props.setFilterEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    if (props.filterEndDateTime) {
                        props.setFilterEndDateTime(null);
                    }
                }} onBlur={(e: any) => {
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        props.setFilterEndDateTime(null);
                    }
                    if (!props.filterEndDateTime) {
                        props.setFilterEndDateTime(getDefaultEndDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр" disabled={props.allTimeChecked}/>
                                    <Calendar
                        key={`end-time-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2 w-full"
                        placeholder="00:00"
                        value={props.endTime ? props.endTime : null}
                        timeOnly
                        hourFormat="24"
                        disabled={props.allTimeChecked}
                        onChange={(e) => {
                            if (e.value) props.setEndTime(e.value);
                        }}
                        onFocus={() => {
                            props.setEndTime(null);
                        }}
                        onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            let digits = input.value.replace(/\D/g, "").slice(0, 4);
                            const HH = digits.slice(0, 2);
                            const MM = digits.slice(2, 4);

                            const display = HH + (digits.length > 2 ? ":" + MM : "");

                            if (input.value !== display) {
                                const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                input.value = display;
                                input.setSelectionRange(caret, caret);
                            }

                            if (digits.length === 4) {
                                const h = parseInt(HH, 10);
                                const m = parseInt(MM, 10);
                                const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                            if (valid) {
                                const base = props.endTime ? new Date(props.endTime) : new Date();
                                base.setHours(h, m, 0, 0);
                                props.setEndTime(base);
                            }
                        }
                    }}
                    onBlur={() => {
                        if (!props.endTime) {
                            props.setEndTime(getDefaultEndTime());
                        }
                    }}
                />
            </div>
    <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6 md:mb-2' : `md:col-4 md:mb-0`} sm:col-12 mb-2 sm:mb-0 p-0 sm:mb-2 justify-content-between flex sm:justify-content-between md:justify-content-start`}>
        {/* <div
            className="align-items-center border-round-lg border-gray-600 border-1 p-2 pt-1 mx-0 md:mx-2 mobile-filter">
            <Checkbox className="mr-2" onChange={e => props.setAllTimeChecked(e.checked)}
                      checked={props.allTimeChecked}/>
            <label>За весь час</label>
        </div> */}
        <Button onClick={() => props.setHasStartFilter(!props.hasStartFilter)}
                disabled={isDisabled()}
                icon="pi pi-search" label="Пошук" className="mobile-filter mobile-filter-btn" style={{minWidth: '30px'}}/>
    </div>

</div>
            </>
    )
}

export default StatusStatisticsListNav;
